module.exports = __webpack_public_path__ + "static/media/19_tn.45531fbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/19_tn.jpg
// module id = 233
// module chunks = 0